import { render, staticRenderFns } from "./dadosComplementares.vue?vue&type=template&id=850549d0&"
import script from "./dadosComplementares.vue?vue&type=script&lang=js&"
export * from "./dadosComplementares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports